import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};
function AssemblyAssets(props: Props) {
  const Navigate = useNavigate();
  const Files:any = [];
  const _handleUploadFile = (event, type) => {
    const config = {
      // bucketName: "moodflik-portal",
      // dirName: "img" /* optional */,
      // region: "us-east-2",
      // accessKeyId: "AKIAWFNJSIDVAQA2KNEU",
      // secretAccessKey: "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",
    };
    const file = event.target.files[0];
    console.log("clicked", file);
    Files.push(file);
    console.log("Files", Files);
    // uploadFile(file, config)
    //   .then((data) => {
    //     // if (type == "cover") {
    //     //   setCover_photo_url(data.location.replace(/ /g, "%20"));
    //     // } else {
    //     //   setProfileImage(data.location.replace(/ /g, "%20"));
    //     // }
    //   })
    //   .catch((err) => console.error(err));
  };
  return (
    <>
      <div className="min-h-full flex items-center justify-center sm:px-6 lg:px-8">
        <div className="w-full space-y-7">
          <div className="flex w-full">
            <label
              className="flex space-x-2 w-full h-80 bg-blue-50 border-2 border-blue-200 rounded-md items-center justify-center cursor-pointer hover:border-blue-100"
              htmlFor="company_icon"
            >
              <div className="flex flex-col">
                <h4 className="text-blue-200">Drag and drop files to upload</h4>
                <h4 className="text-blue-200 ml-10">Pdf/Dpcs/etc.</h4>
              </div>
            </label>
          </div>
          <div className="flex w-full">
          <div className="flex flex-row mt-8 place-content-center bg-blue-50 border-2 border-blue-200 py-2 space-x-2">
                <label
                  htmlFor="file"
                  className="flex flex-wrap cursor-pointer custom-file-upload text-blue-200 font-semibold text-lg"
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    className="mr-2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#1F78B4" />
                    <path
                      d="M6.66406 12.5013H18.3307M12.4974 6.66797V12.5013V18.3346"
                      stroke="white"
                      stroke-width="1.66667"
                    />
                  </svg>{" "}
                  Upload Documents
                </label>
                <input
                  id="file"
                  type="file"
                  className="text-blue-200 font-semibold text-lg hidden"
                  name="file"
                  accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                  onChange={(e) => _handleUploadFile(e, "cover")}
                />
                
                {/* 
                for downloading assets add link to href
                <a href={logo} download>
                mylogo.png
                </a>*/}

                {/* 
                for Viewing on new tab assets add link to href
                <a href={logo} 
                target="_blank"
                 >
                mylogo.png
                </a>
              */}
               
              </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center pt-8 sm:px-6 lg:px-8">
        <div className="w-full space-y-8">
          <div className="flex flex-row space-x-3 justify-center">
            <div className="flex flex-col w-3/5">
              <button
                onClick={() => Navigate("/dashboard/management/items")}
                type="button"
                className="border-2 border-red-700 hover:text-white text-base font-Montserrat font-bold text-red-700 flex-shrink hover:border-red-700 hover:bg-red-700 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
              >
                Cancel
              </button>
            </div>
            <div className="flex flex-col w-1/5">
              {props.ActiveStep > 0 ? (
                <button
                  onClick={props.HandleBack}
                  type="button"
                  className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-40 "
                >
                  Previous Step
                </button>
              ) : null}
            </div>
            <div className="flex flex-col w-1/5">
              <button
                onClick={props.HandleNext}
                type="button"
                className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 flex flex-grow"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssemblyAssets;
